/**
 * 弃用
 */
import { setStore, getStore, clearStore } from "@/utils/storage"

export const TokenKey = 'Access-Token'

export function getToken () {
  return getStore(TokenKey)
}

export function setToken (token) {
  // key, token, timeout = 86400s
  return setStore(TokenKey, token, 86400)
}

export function removeToken () {
  return clearStore(TokenKey)
}
// 存储isystem
export function setisystem (type) {
  return setStore('isystem', type)
}
// 获取isystem
export function getisystem () {
  return getStore("isystem")
}

// 存储isystem
export function setUserID (id) {
  return setStore('userID', id)
}
// 获取isystem
export function getUserID () {
  return getStore("userID")
}

// 存储根节点
export function setDI (rootNode) {
  return setStore('Di', rootNode)
}
// 获取根节点
export function getDI () {
  return getStore("Di")
}